import { create } from 'zustand'
import { KPI } from '../../features/insights_hub/components/TopPerformingAds/__generated__/TopPerformingAdsQuery.graphql'
import { DataGranularity } from '../../layout/Sidebar/__generated__/Sidebar_User.graphql'

export type GlobalBrand = {
  id: string
  name: string
  availableKpis: readonly KPI[]
  config: {
    dataGranularity: DataGranularity | null
  } | null
}
interface GlobalState {
  brand?: GlobalBrand[]
  initialized: boolean
  selectBrand: (brand: GlobalBrand[]) => void
}

export const useGlobalState = create<GlobalState>()((set) => {
  return {
    brand: undefined,
    initialized: false,
    selectBrand: (brand) => {
      set({ brand })
    },
  }
})

export const initializeState = (
  brands: GlobalBrand[],
  brandIds?: string[] | null
) => {
  const defaultBrands = brands.filter((b) => brandIds?.includes(b.id)) || [brands[0]]
  useGlobalState.setState({ brand: defaultBrands, initialized: true })
  return defaultBrands
}